<!-- sku template -->
<ng-template #skuTemplate let-sku="item">

  <!-- template -->
  <deloitteai-sku-card [sku]="sku" (enableSku)="activateSku(sku)" [ngClass]="{'active': sku === activeSku}">
  </deloitteai-sku-card>

  <div class="arrow"></div>
</ng-template>

<!-- plan template -->
<ng-template #planTemplate let-plan="item">
  <deloitteai-plan-card [plan]="plan" (activate)="selectPlan(plan)"></deloitteai-plan-card>
</ng-template>

<!-- view -->
<div class="asset-container pb-3">
  <h4 class=" pt-5 pb-3  font-weight-bold">
    {{ "asset-detail.purchase-section.title" | translate }}
  </h4>
  <p class="d-block pb-3">
    {{ "asset-detail.purchase-section.description" | translate }}
  </p>

  <div *ngIf="skus.length">
    <brain-card-list [source]="skus" [template]="skuTemplate">
    </brain-card-list>
  </div>
</div>

<div class="asset-container pb-3">
  <div *ngIf="plans.length" class="mt-4 pb-3 pb-sm-5">
    <brain-card-list [source]="plans" [template]="planTemplate">
    </brain-card-list>
  </div>
</div>
